var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Col, Row, Container } from "reactstrap";
import Icon from "../../components/Icon";
import { SingleFile, LinkFile, ContentFile, FileDetails, Title } from "./DownloadDocuments.styled";

var DownloadDocuments = function DownloadDocuments(_a) {
  var title = _a.title,
      files = _a.files,
      anchor = _a.anchor,
      props = __rest(_a, ["title", "files", "anchor"]);

  return React.createElement(Container, __assign({
    id: anchor
  }, props), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(Title, null, title)), React.createElement(Col, {
    xs: 12
  }, files.map(function (_a) {
    var name = _a.name,
        details = _a.details,
        url = _a.url,
        target = _a.target;
    return React.createElement(SingleFile, null, React.createElement(ContentFile, null, React.createElement(Icon, {
      name: "Pdf",
      color: "brandGreen",
      width: "64px",
      height: "64px"
    }), React.createElement(FileDetails, null, name, React.createElement("span", null, details))), React.createElement(LinkFile, {
      href: url,
      target: target || "_blank"
    }, React.createElement(Icon, {
      name: "ArrowDownSquare",
      color: "white"
    })));
  }))));
};

export default DownloadDocuments;